module.exports = __webpack_public_path__ + "static/media/pdf-logo.57d3eb4c.svg";